// ============================================================
// 🎮 阿拉德战记 v5.1 — ES Module 入口 (Architecture Cleanup)
// ============================================================
// 架构优化 v5.1:
//   - 所有模块暴露的函数统一挂载到 window.DNF 命名空间
//   - 消除 259 个独立 window.* 绑定 → 1 个 DNF 对象
//   - dnf.html 内联代码通过 DNF.X() 调用，依赖关系一眼可见
//   - IDE 可通过 DNF 对象获得完整的类型提示
// ============================================================

// ── 命名空间 ──
window.DNF = window.DNF || {};

// ── 配置 ──
import * as config from './config.js';
Object.assign(window.DNF, config);

// ── 工具 ──
import * as utils from './utils.js';
Object.assign(window.DNF, utils);

// ── 装备插图 ──
import * as equipmentArt from './equipment_art.js';
Object.assign(window.DNF, equipmentArt);

// ── 状态管理 ──
import * as stateMod from './state.js';
Object.assign(window.DNF, stateMod);

// ── API ──
import * as api from './api.js';
Object.assign(window.DNF, api);

// ── 音效 ──
import * as audio from './audio.js';
Object.assign(window.DNF, audio);

// ── 装备数据 ──
import * as equipDB from './data/equipment.js';
Object.assign(window.DNF, equipDB);

// ── 技能数据 ──
import * as skillsDB from './data/skills.js';
Object.assign(window.DNF, skillsDB);

// ── 职业数据 ──
import * as classesDB from './data/classes.js';
Object.assign(window.DNF, classesDB);

// ── 怪物数据 ──
import * as monstersDB from './data/monsters.js';
Object.assign(window.DNF, monstersDB);

// ── 世界数据 ──
import * as worldDB from './data/world.js';
Object.assign(window.DNF, worldDB);

// ── 地下城配置 ──
import * as dungeonCFG from './data/dungeon-cfg.js';
Object.assign(window.DNF, dungeonCFG);

// ── 角色模型 ──
import * as charModel from './data/character.js';
Object.assign(window.DNF, charModel);

// ── 队伍模型 ──
import * as partyModel from './data/party.js';
Object.assign(window.DNF, partyModel);

// ── 战斗引擎 ──
import * as combatEngine from './engine/combat-system.js';
Object.assign(window.DNF, combatEngine);

// ── 地下城引擎 ──
import * as dungeonEngine from './engine/dungeon-crawl.js';
Object.assign(window.DNF, dungeonEngine);

// ── 经济系统 ──
import * as economy from './engine/economy.js';
Object.assign(window.DNF, economy);

// ── 角色成长 ──
import * as charProg from './engine/character-prog.js';
Object.assign(window.DNF, charProg);

// ── 战斗 UI ──
import * as combatUI from './ui/combat-ui.js';
Object.assign(window.DNF, combatUI);

// ── 菜单 UI ──
import * as menuUI from './ui/menu-ui.js';
Object.assign(window.DNF, menuUI);

// ── 联机客户端 ──
import { mpClient } from './multiplayer/ws-client.js';
window.DNF.mpClient = mpClient;
window.mpClient = mpClient; // 保持向后兼容（联机面板直接引用）

// ── 任务数据 ──
import * as questData from './data/quest-data.js';
Object.assign(window.DNF, questData);

// ── 词缀数据 ──
import * as affixData from './data/affix-data.js';
Object.assign(window.DNF, affixData);

// ── 精灵数据 ──
import * as sprites from './data/sprites.js';
Object.assign(window.DNF, sprites);

// ── 自动连接联机服务器 ──
setTimeout(() => {
  const token = typeof window.getAuthToken === 'function' ? window.getAuthToken() : null;
  if (token) mpClient.connect(token);
}, 500);

// ── 向后兼容：关键函数保留 window.* 引用 ──
// 这些是 dnf.html 内联代码通过全局变量直接调用的
window.S = window.DNF.S;
window.SAVE_KEY = window.DNF.SAVE_KEY;
window.VERSION = window.DNF.VERSION;
window.API_BASE = window.DNF.API_BASE;
window.AUTH_KEY = window.DNF.AUTH_KEY;
window.CHAR_KEY = window.DNF.CHAR_KEY;
window.toast = window.DNF.toast;
window.CLASSES = window.DNF.CLASSES;
window.SKILLS_DB = window.DNF.SKILLS_DB;
window.CONSUMABLES = window.DNF.CONSUMABLES;
window.EQUIPMENT_DB = window.DNF.EQUIPMENT_DB;
window.TIERS = window.DNF.TIERS;
window.ITEM_ICONS = window.DNF.ITEM_ICONS;
window.getEquipById = window.DNF.getEquipById;
window.getEquipStats = window.DNF.getEquipStats;
window.getMonsterData = window.DNF.getMonsterData;
window.getMonsterImage = window.DNF.getMonsterImage;
window.MAPS = window.DNF.MAPS;
window.save = window.DNF.save;
window.load = window.DNF.load;
window.defaultState = window.DNF.defaultState;
window.renderTopbar = window.DNF.renderTopbar;
window.renderStatusbar = window.DNF.renderStatusbar;
window.switchBGM = window.DNF.switchBGM;
window.apiCall = window.DNF.apiCall;
window.currentCharId = window.DNF.currentCharId;

console.log('✅ 阿拉德战记 v5.1 — 模块已加载 (via DNF namespace)');
console.log('   地图:', Object.keys(window.DNF.MAPS || {}).join(', '));
console.log('   装备:', (window.DNF.EQUIPMENT_DB || []).length, '件');

window.__modulesReady = true;
if (typeof window.__onModulesReady === 'function') {
  window.__onModulesReady();
}
